import axios from 'axios'
import { store } from '@/store'

export const api = axios.create({
  baseURL: '/checkout/api',
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

export const fetchDataBeforeRoute = (readAction, resetAction) => async (
  to,
  from,
  next
) => {
  if (to.params.id) {
    await store.dispatch(readAction, to.params.id)
  } else {
    await store.dispatch(resetAction)
  }
  next()
}

export const fetchListBeforeRoute = (listAction) => async (to, from, next) => {
  await store.dispatch(listAction)
  next()
}
